// extracted by mini-css-extract-plugin
module.exports = {"markAllWrapper":"style_markAllWrapper__3aS2N","markAllBtn":"style_markAllBtn__2glhb","markAllText":"style_markAllText__1COFm","markAllIcon":"style_markAllIcon__3ktmc"};